import { GridColumnType } from "../../data/gridColumnType";
const AllInterviewConfig = {
    columns: [
        {
            name: "Full Name",
            fieldName: "firstName,lastName",
            colType: GridColumnType.CUSTOM,
            renderCustomCol: (rowData) => {
                return rowData?.["firstName"] + " " + rowData?.["lastName"];
            },
        },
        {
            name: "Email Address",
            fieldName: "contactEmail",
        },
        {
            name: "Position Applied",
            fieldName: "positionName",
        },
        {
            name: "Interviewer Name",
            fieldName: "interviewerName",
        },
        {
            name: "Interview Date",
            fieldName: "interviewDate",
            colType: GridColumnType.DATE,
            colSettings: {
                format: "DD/MM/YYYY hh:mm A",
            },
        },
        // {
        //     name: "Action",
        //     colType: GridColumnType.ACTION,
        // },
    ],
};

export default AllInterviewConfig;